import React, { useEffect, useState } from 'react';
import { Route, useHistory } from 'react-router-dom';
import { GetLocalStorageValue } from '../../_config/utils/get-local-storage-value.util';
import { Service } from './service';

export default function PrivateRoute({ component: Component, ...rest }) {
	const history = useHistory();
	const { email, token } = GetLocalStorageValue('userInfo');
	const [admin, setAdmin] = useState(null);

	useEffect(() => {
		new Service()
			.findUser(token)
			.then((response) => {
				setAdmin(response.admin);
				if (!response.admin) {
					history.push('/');
				}
			})
			.catch((error) => {
				console.log('error:', error);
			});
	}, [email, history, token]);

	return <Route {...rest} render={(props) => (admin ? <Component {...props} /> : null)} />;
}
